const Time = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z" fill="currentColor"/>
      <path d="M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V11.809C11 12.1964 11.1539 12.5679 11.4278 12.8418L13.586 15C13.9765 15.3905 14.6095 15.3905 15 15C15.3905 14.6095 15.3905 13.9765 15 13.586L13.3517 11.9377C13.1265 11.7125 13 11.4071 13 11.0887V8Z" fill="currentColor"/>
    </svg>
  );
};

export default Time;